import footerStyle from '@salesforce/retail-react-app/app/theme/components/project/footer'
import {remCalc} from '../../_utils'

export default {
    ...footerStyle,
    parts: [
        'container',
        'content',
        'subscribe',
        'subscribeField',
        'subscribeButtonContainer',
        'subscribeHeading',
        'subscribeMessage',
        'localeSelector',
        'bottomHalf',
        'horizontalRule',
        'copyright',
        'socialIcons',
        'iconsBenefitSection',
        'simpleGrid',
        'lineCosmeticContainer',
        'lineCosmeticIcon',
    ],
    baseStyle: {
        outerContainer: {
            display: 'flex',
            justifyContent: 'center',
            width: 'full',
            background: 'background.accent.default',
        },
        container: {
            width: 'full',
            background: 'background.accent.default',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: remCalc(0),
        },
        footerContentContainer: {
            position: 'relative',
            display: 'flex',
            flexDirection: {base: 'column', lg: 'row'},
            justifyContent: 'space-between',
            alignItems: {base: 'center', lg: 'flex-start'},
            width: 'full',
            maxWidth: remCalc(1512),
            marginX: 'auto',
            paddingX: {
                base: 'xsmall.xl',
                lg: 'medium.xl',
            },
            paddingY: {
                base: 'small.xl',
                lg: 'medium.xl',
            },
            gap: {base: 'small.xl', lg: remCalc(40)},
            _after: {
                content: '""',
                display: {base: 'block', lg: 'none'},
                position: 'absolute',
                top: '100%',
                left: '50%',
                transform: 'translateX(-50%)',
                width: remCalc(313),
                maxWidth: '100%',
                height: remCalc(1),
                background: 'var(--border-neutral-default, rgba(239, 237, 234, 0.08))',
            },
        },
        containerSpacing: {
            '@media (max-width: 1199px)': {
                paddingY: 'small.base',
                mx: 0,
                px: 'small.base',
                paddingBottom: remCalc(16),
                paddingTop: remCalc(16),
            },
            '@media (min-width: 1200px) and (max-width: 1399px)': {
                paddingY: 'small.lg',
                mx: 0,
                px: 'small.base',
            },
            '@media (min-width: 1400px)': {
                paddingY: remCalc(30),
                mx: 'auto',
            },
        },
        localeSelector: {
            w: '85px',
        },
        copyright: {
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
            color: 'foreground.neutral.inverse',
            w: 'full',
        },
        policies: {
            textStyle: 'body-small',
            color: '#8A95B7',
            fontWeight: 'medium',
            height: 'fit-content',
            marginY: {base: 0, lg: remCalc(4)},
            _active: {
                color: 'foreground.neutral.inverse',
            },

            _hover: {
                color: 'foreground.neutral.inverse',
            },
        },
        teconsent: {
            _hover: {
                textDecoration: 'underline',
            },
            textStyle: 'body-xsmall',
            borderLeft: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            paddingLeft: 'xsmall.base',
            color: 'text.inverse',
            opacity: '0.7',
            fontWeight: 'medium',
        },
        socialIcons: {
            display: 'flex',
            alignItems: 'center',
            gap: {base: 'xxsmall.xl', lg: 'xsmall.xl'},
        },
        verticalLineIcon: {
            width: remCalc(1),
            height: remCalc(32),
            color: 'border.neutral.footer',
        },
        socialsContainer: {
            w: remCalc(32),
            h: remCalc(32),
            display: 'flex',
            paddingY: 'xxsmall.xl',
            paddingX: 'xxxsmall-1.xl',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 'large',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-footer) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',

            _hover: {
                bg: 'background.accent.hover',
            },
        },
        socialIcon: {
            width: remCalc(16),
            height: remCalc(16),
            color: 'background.base.inverse',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        socialApp: {
            alignItems: 'center',
            gap: 'xsmall.xl',
            justifyContent: 'flex-end',
        },
        appIcons: {
            alignItems: 'center',
            gap: remCalc(12),
        },
        appIcon: {
            width: remCalc(105),
            height: remCalc(31),
        },
        benefitIcons: {
            color: 'background.light-blue',
            boxSize: ['iconsSize.xlarge'],
        },
        iconsBenefitSection: {
            display: 'grid',
            gridTemplateRows: 'auto', // Keep rows auto-sized
            justifyContent: {base: 'center', md: 'space-between'},
            paddingInline: {base: '0', md: remCalc(24), lg: remCalc(50)},
            alignItems: 'center',
            w: '100%',
        },
        benefitText: {
            color: 'text.inverse',
            textStyle: 'body-large',
            textAlign: 'center',
            display: 'block',
            fontWeight: 'bold',
            maxWidth: {base: remCalc(140), md: remCalc(236)},
        },
        benefitStack: {
            alignItems: 'center',
            gap: remCalc(16),
            textAlign: 'center',
            minHeight: remCalc(120),
        },
        dividerRule: {
            color: 'border.neutral.footer',
            borderBottomWidth: remCalc(2),
            opacity: '0.1',
        },
        paymentsSection: {
            display: 'grid',
            gridTemplateColumns: `repeat(6, ${remCalc(48)})`,
            w: 'fit-content',
            alignItems: 'center',
            gap: {base: 'xxsmall.xl', lg: 'xsmall.xl'},
        },
        paymentIconContainer: {
            w: remCalc(48),
            h: remCalc(32),
            display: 'flex',
            paddingY: 'xxsmall.xl',
            paddingX: 'xxxsmall-1.xl',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 'large',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-footer) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
        },
        paymentIcon: {
            width: remCalc(32),
            height: remCalc(10),
            objectFit: 'contain',
        },
        brandAndLinks: {
            flexDir: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: 'xxsmall.xl',
            w: 'full',
        },
        countryPayments: {
            alignItems: 'flex-start',
            gap: remCalc(24),
            flexShrink: '0',
        },
        paymentsLegalOuterContainer: {
            layerStyle: 'page',
            flexDir: 'column',
        },
        paymentsLegal: {
            w: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        footerLiteContainer: {
            flexDir: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: remCalc(16),
            w: 'full',
        },
        footerBrandLogo: {
            width: remCalc(76.96),
            height: remCalc(23.8),
        },
        // socialAppPrivacy: {
        //     gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        // },
        linkColumnContainer: {
            w: '100%',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 'medium.xl',
        },
        footerBrand: {
            width: remCalc(116.204),
            height: remCalc(36),
        },
        mobileStack: {
            gap: remCalc(20),
            alignItems: 'flex-start',
            paddingX: 'xsmall.xl',
            paddingY: 'small.xl',
        },
        mobileIconsContainer: {
            gap: 'xxsmall.xl',
            flexDir: 'column',
            alignItems: 'flex-start',
            width: '100%',
            alignSelf: 'stretch',
        },
        mobileSocialCountryContainer: {
            flexDir: 'row',
            gap: 'xxsmall.xl',
        },
        mobileVatLegalContainer: {
            flexDir: 'column',
            gap: 'xxsmall.xl',
            justifyContent: 'center',
            alignItems: 'flex-start',
        },
        accordionHeading: {
            color: 'foreground.neutral.inverse',
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        accordionIconContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        accordionIcon: {
            color: 'foreground.neutral.inverse',
            boxSize: remCalc(10.83),
        },
        accordionList: {
            color: '#8A95B7',
            textStyle: 'body-small',
            paddingY: remCalc(16),
            fontWeight: 'medium',
        },
        accordionItem: {
            borderColor: 'border.neutral.footer',
            borderTopWidth: 0,
            borderBottomWidth: remCalc(1),
            _last: {borderBottomWidth: 0},
            paddingInline: '0',
            paddingY: remCalc(18),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        accordionButton: {
            alignItems: 'center',
            _hover: {
                bg: 'transparent',
            },
        },
        standardLinkGrid: {
            w: '100%',
            gridTemplateColumns: {base: '1fr', lg: 'repeat(5, 1fr)'},
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: {base: 0, lg: 'medium.xl'},
        },
        standardLinkContainer: {
            w: '100%',
        },
        standardLinkColumn: {
            borderColor: 'border.neutral.footer',
            borderBottomWidth: {base: remCalc(1), lg: 0},
            // _last: {borderBottomWidth: 0},
            paddingY: {base: remCalc(18), lg: 0},
        },
        standardLinkHeading: {
            display: {base: 'none', lg: 'block'},
        },
        standardLinkToggle: {
            display: {base: 'flex', lg: 'none'},
            w: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            _hover: {bg: 'transparent'},
        },
        standardLinkList: {
            flexDir: 'column',
            display: {base: 'none', lg: 'flex'},
            gap: {base: 0, lg: 'xxsmall.xl'},
        },
        standardLinkListOpen: {
            display: 'flex',
        },
        standardLinkItem: {
            paddingY: {base: remCalc(16), lg: 0},
        },
        hideOnMobile: {display: {base: 'none', lg: 'block'}},
        hideOnDesktop: {display: {base: 'block', lg: 'none'}},
        cartFooterBrand: {
            display: {base: 'none', lg: 'block'},
        },
        cartBrandLegal: {
            justifyContent: {base: 'center', lg: 'space-between'},
            alignItems: 'center',
            w: '100%',
        },
        copyPositioning: {
            position: {base: 'relative', lg: 'absolute'},
            bottom: {base: 'auto', lg: remCalc(40)},
            right: {base: 'auto', lg: remCalc(40), '2xl': remCalc(255)},
            width: {base: '100%', lg: 'auto'},
            textAlign: 'center',
        },
        socialAppPrivacyContainer: {
            gap: remCalc(40),
        },
        braunCountryLegal: {
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        brandCopyContainer: {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: remCalc(16),
        },
        footerOuterContainer: {
            background: 'background.accent.default',
        },
        simpleGrid: {},
        legalLinks: {
            flexDir: 'row',
            gap: {
                base: 'xxxsmall-1.base',
                md: 'xxxsmall-1.md',
                lg: 'xxxsmall-1.lg',
                xl: 'xxxsmall-1.xl',
            },
            flexWrap: 'wrap',
        },
        legalLinkFlex: {
            flexDir: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: {
                base: 'xxxsmall-1.base',
                md: 'xxxsmall-1.md',
                lg: 'xxxsmall-1.lg',
                xl: 'xxxsmall-1.xl',
            },
        },
        legalLink: {
            color: '#8A95B7',
            height: remCalc(14),
            alignItems: 'baseline',

            _active: {
                color: 'foreground.neutral.inverse',
            },

            _hover: {
                color: 'foreground.neutral.inverse',
            },
        },
        legalLinksSeperatorContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: {
                base: 'xxxsmall.base',
                md: 'xxxsmall.md',
                lg: 'xxxsmall.lg',
                xl: 'xxxsmall.xl',
            },
        },
        legalLinksSeperator: {
            color: '#374B8A',
            width: remCalc(8),
            height: remCalc(10),
        },
        lineCosmeticContainer: {
            flexDirection: 'column',
            width: 'full',
            alignSelf: 'stretch',
            alignItems: 'center',
            justifyContent: 'center',
            gap: {
                base: 'xxxsmall.base',
                md: 'xxxsmall.md',
                lg: 'xxxsmall.lg',
                xl: 'xxxsmall.xl',
            },
            paddingY: {
                base: 'xxxsmall.base',
                md: 'xxxsmall.md',
                lg: 'xxxsmall.lg',
                xl: 'xxxsmall.xl',
            },
        },
        lineCosmeticIcon: {
            width: 'full',
            alignSelf: 'stretch',
            bg: 'background.strong.footer',
            opacity: 1,
            borderBottomWidth: remCalc(1.5),
        },

        newsletter: {
            footerContainer: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: {base: 'large.base', md: 'large.md', lg: 'large.lg', xl: 'large.xl'},
                alignSelf: {base: 'auto', lg: 'stretch'},
                width: 'full',
                maxWidth: {base: '100%', lg: remCalc(308)},
                paddingRight: {
                    base: 0,
                    md: 0,
                    lg: 'xsmall-1.lg',
                    xl: 'xsmall-1.xl',
                },
            },
            brandLogo: {
                width: remCalc(77),
                height: remCalc(24),
                flexShrink: 0,
            },
            contentContainer: {
                flexDirection: 'column',
                gap: 'xsmall.xl',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
            },
            textStack: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
            },
            header: {
                textStyle: 'body-xxlarge',
                color: 'foreground.neutral.inverse',
                fontFamily: 'heading',
            },
            subtitle: {
                textStyle: 'body-xxlarge',
                color: '#6C7BA8',
                fontFamily: 'heading',
            },
            button: {
                w: 'full',
            },
            disclaimerStack: {
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
            },
            disclaimerText: {
                textStyle: 'body-xxsmall',
                color: '#6C7BA8',
            },
        },
        brandLogoSection: {
            container: {
                layerStyle: 'page',
                width: 'full',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                paddingTop: {
                    base: 'xsmall.xl',
                    lg: 'medium.xl',
                },
                paddingX: {
                    base: 'xsmall.xl',
                    lg: 'medium.xl',
                },
            },
            logo: {
                width: 'full',
                height: 'auto',
                aspectRatio: '1432 / 169',
                color: '#F0EFEF',
                display: 'block',
            },
        },
    },
    variants: {
        checkout: {
            container: {
                maxWidth: 'container.xxl',
                margin: 'auto',
                paddingInline: remCalc(0),
                paddingTop: {sm: remCalc(16), md: remCalc(16), lg: remCalc(16), xl: remCalc(30)},
                paddingBottom: {sm: remCalc(16), md: remCalc(16), lg: remCalc(16), xl: remCalc(30)},
            },
        },
        braun: {
            simpleGrid: {
                spacingX: {base: remCalc(16), md: remCalc(64), lg: 'auto'},
                spacingY: {base: remCalc(16), lg: 0},
                paddingY: {base: remCalc(16), lg: remCalc(32), xl: 0},
                paddingX: {base: remCalc(0), xl: remCalc(50)},
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                alignSelf: 'stretch',
                gridTemplateRows: 'auto',
            },
        },
    },
}
